import { useErrorBoundary } from 'react-error-boundary'
import { handleError } from '@velasca/utils/handle-error'
import { Button } from '../Button/Button'
import { SansText } from '../SansText/SansText'
import { Container } from './ErrorFallback.styles'
import type { ErrorFallbackProps } from './ErrorFallback.types'

export const ErrorFallback = ({ error }: ErrorFallbackProps): JSX.Element => {
  handleError(error)
  const { resetBoundary } = useErrorBoundary()

  return (
    <Container role="alert">
      <p>
        Contenuto non disponibile.
        <br /> Si prega di riprovare più tardi .
      </p>
      <Button variant="ghost" text="Riprova" onClick={resetBoundary} />
      <Button
        text="Ricarica la pagina"
        onClick={() => {
          window.location.reload()
        }}
      />
      <SansText underline fontWeight="500" color="primary" as="a" href="/">
        Torna alla Homepage
      </SansText>
    </Container>
  )
}
